
export default function reducer(state = {}, action){
  const prefix = window.RAH_prefix

  switch (action.type) {
    case `${prefix}_INIT`:
      return action.payload

    default:

  }
  return state
}



// WEBPACK FOOTER //
// ./src/redux/redux-api-handler/reducer.js